export const updateCurrentPopup = (comps: Array<string>, currentPopupId?: string) => {
	return comps.reduce<Record<string, { currentPopupId?: string }>>((updatedObject, compId: string) => {
		updatedObject[compId] = { currentPopupId }
		return updatedObject
	}, {})
}
